import { Directive, HostListener, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[drop-file]' // Attribute selector
})
export class DropFileDirective {
    @Output() private filesChangeEmiter: EventEmitter<any> = new EventEmitter();
    
    constructor() {
    }

    @HostListener('dragover', ['$event']) public onDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('drop', ['$event']) public onDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        let selectedFile = event.dataTransfer.files[0];
        this.getBase64(selectedFile).then((res)=>{
            this.filesChangeEmiter.emit(res);
        }).catch((err) => {
            console.log(err);
        })
    }
    
    getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
}


// WEBPACK FOOTER //
// ./src/directives/drop-file/drop-file.ts